import imageCompression from 'browser-image-compression';

export interface ImageCompressionOptions {
  maxSizeMB?: number;
  maxWidthOrHeight?: number;
  quality?: number;
}

const DEFAULT_OPTIONS: Required<ImageCompressionOptions> = {
  maxSizeMB: 0.5,
  maxWidthOrHeight: 800,
  quality: 0.8,
};

export async function compressImageToBase64(
  file: File,
  options: ImageCompressionOptions = {},
): Promise<string> {
  const opts = { ...DEFAULT_OPTIONS, ...options };

  const compressedFile = await imageCompression(file, {
    maxSizeMB: opts.maxSizeMB,
    maxWidthOrHeight: opts.maxWidthOrHeight,
    useWebWorker: true,
    fileType: 'image/jpeg',
    initialQuality: opts.quality,
  });

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject(new Error('Failed to convert file to base64'));
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(compressedFile);
  });
}

export async function compressBase64Image(
  base64String: string,
  options: ImageCompressionOptions = {},
): Promise<string> {
  const opts = { ...DEFAULT_OPTIONS, ...options };

  const response = await fetch(base64String);
  const blob = await response.blob();
  const file = new File([blob], 'image.jpg', { type: 'image/jpeg' });

  return compressImageToBase64(file, opts);
}
